import { styled } from "@vw-marketing/us-components";

export const StyledPaginationInformationContainer = styled.div`
   padding-top: 10px;
`
